document.addEventListener("DOMContentLoaded", function() {
  const POLLING_INTERVAL = 10;
  
  const interval = setInterval(setFlickityHeight, POLLING_INTERVAL);
  
  function setFlickityHeight() {
    try {
      const slider = document.querySelector("main .shopify-section:first-child .slideshow .flickity-viewport");
      const sliders = slider.querySelectorAll(".slideshow__slide");
      
      if (sliders && slider) {
        const largestSlide = Math.max(...Array.from(sliders).map(slide => slide.offsetHeight));
        
        if (slider.style.height === largestSlide + "px") {
          return;
        }
        
        slider.style.height = largestSlide + "px";
      }
    }
    
    catch (error) {
      console.log("Hero image fix failed");
      console.log("Error: ", error);
      
      clearInterval(interval);
    }
  }
});

